var Handlebars = require("../../../../../../../../node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
    var alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "  <a class=\"btn text-tool item\" data-size=\""
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"size") : depth0), depth0))
    + "\"  style=\"font-size: "
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"fontSize") : depth0), depth0))
    + "px; font-family: "
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"fontFamily") : depth0), depth0))
    + "\">\n    "
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"textContent") : depth0), depth0))
    + "\n    <span class=\"hidden\">"
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"textBlock") : depth0), depth0))
    + "</span>\n  </a>\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = __default(require("../../../../../../../../src/utils/handlebars-helpers/list.js")).call(depth0 != null ? depth0 : (container.nullContext || {}),depth0,{"name":"list","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":0},"end":{"line":6,"column":9}}})) != null ? stack1 : "");
},"useData":true});